// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"364":"6a8fdfbcdb64b5b933ca","414":"f432514cc32df7739085"}[chunkId] + ".chunk.js";
};